var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('field-select-module',{attrs:{"board":this.board,"is-print":_vm.isPrint},model:{value:(_vm.form.stdInfo),callback:function ($$v) {_vm.$set(_vm.form, "stdInfo", $$v)},expression:"form.stdInfo"}}),_c('table-company-group',{staticClass:"mt-5",attrs:{"title":"관리자 그룹","list":_vm.form.group1,"isPrint":_vm.isPrint,"isReadonly":_vm.board.readonly,"positionList":[
      '기관장',
      '국장',
      '부서장',
      '과장',
      '안전보건총괄책임자',
      '안전보건책임자',
      '안전보건조정자',
      '관리감독자',
      '안전관리자',
      '보건관리자',
      '산업보건의',
      '현장관리자',
      '안전담당자',
      '보건담당자',
      '담당자',
      '기타',
    ]},on:{"updateList":_vm.updateGroupList}}),_c('file-upload-module',{staticClass:"mt-5",attrs:{"readonly":_vm.board.readonly,"is-print":_vm.isPrint},model:{value:(_vm.form.fileList),callback:function ($$v) {_vm.$set(_vm.form, "fileList", $$v)},expression:"form.fileList"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }